import { Component, SyntheticEvent } from "react";
import * as React from "react";
import { IProduct } from "../../api/models/Product";

import "./ProductSelector.css"

interface IProductSelectorProps {
    amount: number;
    product: IProduct;
    onChange: (newAmount: number) => void;
    disabled?: boolean;
}

export class ProductSelector extends Component<IProductSelectorProps> {
    constructor(props: any) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    public render() {
        const prod = this.props.product;
        const { disabled } = this.props;

        let priceText = `${prod.price.toFixed(2)} EUR`;
        if (prod.reduction) {
            priceText += ` (${prod.reduction.price.toFixed(2)} EUR ab ${prod.reduction.minAmount} STK)`;
        }

        // Calculate the product price based on a possible reduction
        const pricePer = (prod.reduction && this.props.amount >= prod.reduction.minAmount) ? prod.reduction.price : prod.price;
        
        return (
            <div className="cell card medium-6 product-selector">
                <div className="grid-x">
                    <div className="cell medium-6 left">
                        <img src={prod.imgUrl} alt="Produkt"/>
                    </div>
                    <div className="cell medium-6 right">
                        <span className="title">{prod.title}</span>
                        <hr/>
                        <span className="price-single">{priceText}</span>
                        <br/>
                        <span className="input-label">Bestellmenge:</span>
                        <div className="grid-x">
                            <input type="number" onChange={this.handleChange} value={this.props.amount} min={0} disabled={disabled}/>
                        </div>
                        <span className="price-sum">Gesamtwert: {(this.props.amount * pricePer).toFixed(2)} EUR</span>
                    </div>
                </div>
            </div>
        )
    }

    private handleChange(event: SyntheticEvent) {
        const newVal = parseInt((event.target as HTMLInputElement).value, 10);
        this.props.onChange(newVal);
    }
}



// WEBPACK FOOTER //
// ./src/components/product/ProductSelector.tsx